import React, { Component } from "react";
import ExperienceCard from "../../components/experienceCard/ExperienceCard.js";
import "./ExperienceAccordion.css";
import { Accordion, Panel } from "baseui/accordion";

class ExperienceAccordion extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="experience-accord">
        <Accordion
          onChange={({ expanded }) => console.log(expanded)}
          overrides={{
            Header: {
              style: () => ({
                color: "#e4e6eb",
                backgroundColor: "#242526",
                border: "#000",
                borderBottom: "#000",
              }),
            },
            Content: {
              style: () => ({
                backgroundColor: "#202020",
              }),
            },
          }}
        >
          {this.props.sections.map((section) => {
            return (
              <Panel
                className="accord-panel"
                title={section["title"]}
                key={section["title"]}
              >
                {section["experiences"].map((experience) => {
                  return (
                    <ExperienceCard experience={experience} theme={theme} />
                  );
                })}
              </Panel>
            );
          })}
        </Accordion>
      </div>
    );
  }
}

export default ExperienceAccordion;
